import React, { useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../redux/actions'
import rp from 'request-promise-native'
import moment from 'moment'
import { uriV2, instantProductsUpdateClients } from '../../services/defaultProps'

import menu from '../../constants/Menu'
import productsText from '../../constants/Cromatica'
import { FiArrowLeft } from 'react-icons/fi'
import Header from '../../components/Header.js'
import { useHistory } from 'react-router-dom'
import '../../styles/containers/CromaMenu.css'
import PerfilGridSkeleton from '../../components/PerfilGridSkeleton'

const Option = ({ title, icon, history, path, numberOfNews, setDateOfLastReading }) => {
  const notification = numberOfNews > 15 ? '+15' : numberOfNews

  return (
    <div className='croma-menu-option'
      onClick={() => {
        if (setDateOfLastReading) {
          setDateOfLastReading(new Date().toISOString())
        }
        if (title === 'Trend') {
          history.push(`${path}`)
        } else {
          history.push(`/cor${path}`)
        }
      }}
    >
      <div className='croma-menu-inneroption'>
        {!!numberOfNews && <div className='croma-menu-notification'>{notification}</div>}
        <div className='croma-menu-image'>
          <img src={icon} alt={title} />
        </div>
        <div className='croma-menu-option-title'>{title}</div>
      </div>
    </div>
  )
}

const Menu = ({ language, ...props }) => {
  const optionsOrder = [
    'sheet',
    'makeup',
    'hair',
    'look',
    'accessories'
  ]

  const menuOptions = {
    sheet: {
      title: 'Cartela online',
      icon: 'assets/sheet.png',
      path: '/cartela'
    },
    makeup: {
      title: 'Maquiagem',
      icon: 'assets/makeup.png',
      path: '/maquiagem/categoria'
    },
    hair: {
      title: 'Cabelo',
      icon: 'assets/hair.png',
      path: '/cabelo/categoria'
    },
    look: {
      title: 'Looks',
      icon: 'assets/look.png',
      path: '/looks/categoria'
    },
    accessories: {
      title: 'Acessórios',
      icon: 'assets/accessories.png',
      path: '/acessorios/categoria'
    }
  }

  if ((props.user.contrast && !menuOptions.contrast) || (props.user.contrast && menuOptions.trending)) {
    optionsOrder.splice(5, 1)
    optionsOrder.push('contrast')
    menuOptions.contrast = {
      title: 'Contraste',
      icon: 'assets/contrast.png',
      path: '/contraste'
    }
  } else if ((!props.user.contrast && !menuOptions.trending) || (!props.user.contrast && menuOptions.contrast)) {
    optionsOrder.splice(5, 1)
    optionsOrder.push('trending')
    menuOptions.trending = {
      title: 'Trend',
      icon: 'assets/trend.png',
      path: '/trend'
    }
  }

  const [loading, setLoading] = useState(true)

  const history = useHistory()

  const getSubgroupItems = useCallback(async () => {
    await rp({
      uri: `${uriV2}/product/user-products?coloringType=${productsText.colorMatcher[props.user.personalColoring - 1]}`,
      method: 'GET',
      headers: {
        Authorization: props.token
      },
      json: true
    }).then((response) => {
      props.setSubgroupItems({ subgroupItems: response })
      props.setProductsLastFetch({ lastFetch: moment() })
    }).catch(err => console.error(err))
  }, [props.user.personalColoring, props.token])

  const renderOptions = () => {
    return (
      <div className='croma-menu-options'>
        {optionsOrder.map((option, idx) => (
          option === 'trending' ? <Option key={idx} {...menuOptions[option]} history={history} numberOfNews={props.numberOfNewPosts} setDateOfLastReading={props.setDateOfLastReading} />
            : <Option key={idx} {...menuOptions[option]} history={history} />
        ))}
      </div>
    )
  }

  useEffect(() => {
    const getSubgroupItemsOnMount = async () => {
      if (!props.products.lastFetch ||
        moment().diff(props.products.lastFetch, 'minutes') > 10 ||
        instantProductsUpdateClients.includes(props.user.id)) {
        setLoading(true)
        await getSubgroupItems()
      }
      setLoading(false)
    }

    getSubgroupItemsOnMount()
  }, [])

  return (
    <div className='croma-menu-container'>
      <Header language={language} />
      <div className='croma-menu-title'>
        <FiArrowLeft onClick={() => history.push('/')}
          size={24} color='var(--primary)' className='croma-menu-goback' />
        <p>{menu.color[language]}</p>
      </div>
      {loading ? (
        <PerfilGridSkeleton />
      ) : renderOptions()}
    </div>
  )
}

const mapStateToProps = state => ({
  ...state.userReducer,
  numberOfNewPosts: state.notificationReducer.trends.numberOfNewPosts,
  products: state.productsReducer
})

export default connect(mapStateToProps, actions)(Menu)



// WEBPACK FOOTER //
// ./src/containers/Cromatica/Menu.js